// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'

import './assets/css/style.scss'
import './assets/fonts/iconfont.css'
// import 'element-ui/lib/theme-chalk/index.css'  //不要引入，否则 scrollbar 出现块状

import {
  Container,Header, Aside, Main, Footer,
  Message,Loading,MessageBox,Notification,
  Steps,Step,Scrollbar,
  Row,Col,
  Form,FormItem,Input,Button,
  Dialog,Switch,
  Select,Option,
  Tooltip,DatePicker,
  Menu,MenuItem,
  Table,TableColumn,
  RadioGroup,RadioButton,
  Dropdown,DropdownMenu,DropdownItem
} from 'element-ui';

Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Loading)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Scrollbar)
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tooltip)
Vue.use(DatePicker)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)

Vue.config.productionTip = false

Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;

Vue.config.devtools = true;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js